import React, { useContext } from 'react'

import { Button } from '@CoreComponents/Buttons/Button'
import { ProductSearchContext } from '@Globals/Algolia/Context'
import { useTranslation } from '@Globals/Translations'

import styles from './NoProducts.module.scss'

export const ProductListNoProducts = () => {
  const { resetFilters } = useContext(ProductSearchContext)
  const { t } = useTranslation()

  return (
    <div className={styles.noProductsAvailable}>
      <span>{t('products:FILTER_ZERO_RESULTS_MESSAGE_TITLE')}</span>
      <span>{t('products:FILTER_ZERO_RESULTS_MESSAGE_TEXT')}</span>
      <Button
        aria-label={t('products:FILTER_RESET_ALL_LABEL')}
        innerSpacing="medium"
        onClick={resetFilters}
        theme="black"
      >
        {t('products:FILTER_RESET_ALL_LABEL')}
      </Button>
    </div>
  )
}
